"use client";

import { ContactFormVariant } from "@/app/components/forms/contact/contact-form-variant";

export function GiveawayForm() {
  return (
    <ContactFormVariant
      variant="giveaway"
      showHeader
      presentation="card"
      className="rounded-2xl bg-white"
    />
  );
}
